import { useEffect } from "react";
import {
  UPDATE_CART_DATA,
  EMPTY_CART,
  ADD_TO_CART,
  GET_BLOGS,
  GET_PRODUCTS,
  REMOVE_FROM_CART,
  DECREASE_COUNT_FROM_CART,
  GET_USER,
  SET_USER,
  REMOVE_USER,
  SET_USER_ADDRESS,
  SET_SHOW_ALL_NUM,
} from "../Types";
import { combineReducers } from "redux";

const initialState = {
  products: [],
  cart: [],
  blogs: [],
  user: [],
  showAllNum: null,
};

const cartReducer = (state = initialState.cart, action) => {
  switch (action.type) {
    case UPDATE_CART_DATA:
      if (state.length <= 0 && action.payload?.length > 0) {
        return action.payload;
      } else {
        const newCartData = action.payload?.filter((item) => item.orderDetailId != state.orderDetailId);
        return newCartData;
      }

    // let lastServices = state.services?.filter((item) => item.serviceId != action.payload?.serviceId);
    // let newService = action.payload;
    // services = [...lastServices, newService];
    // return { ...state, services };

    // return {
    //   ...state,
    //   services: [
    //     ...state.services?.map((item) => {
    //       if (item.serviceId == action.payload?.serviceId) {
    //         return action.payload;
    //       }
    //       return item;
    //     }),
    //   ],
    // };

    // return { ...state, lastServices };

    case EMPTY_CART:
      // const cartData = state.filter((item) => item.orderDetailId == action.payload.orderDetailId);
      return [];
    case ADD_TO_CART:
      const product = state.find(
        (item) =>
          item.id == action.payload.id &&
          item.isApproved == action.payload.isApproved &&
          item.providerId === action.payload.providerId
      );
      if (product) {
        return state.map((item) => {
          if (
            item.id == action.payload.id &&
            item.isApproved == action.payload.isApproved &&
            item.providerId === action.payload.providerId
          ) {
            product.count += 1;
            return product;
          } else {
            return item;
          }
        });

        // product.count += 1;
        // const products = state.filter((item) => item.id != action.payload.id);
        // return [...products, product];
      }
      action.payload.count = 1;
      return [...state, action.payload];
    case REMOVE_FROM_CART:
      const allState = state;
      let found = state.findIndex(
        (item) =>
          item.id == action.payload.id &&
          item.isApproved == action.payload.isApproved &&
          item.providerId === action.payload.providerId
      );
      allState.splice(found, 1);
      return [...allState];
    // this ifCheck is for procucts with differents id's
    // if (state.filter((item) => item.id == action.payload.id).length > 1) {
    // } else {
    //   return state.filter((item) => item.id != action.payload.id);
    // }
    case DECREASE_COUNT_FROM_CART:
      let productSelected = state.find(
        (item) =>
          item.id == action.payload.id &&
          item.isApproved == action.payload.isApproved &&
          item.providerId === action.payload.providerId
      );

      const allState2 = state;
      let found2 = state.findIndex(
        (item) =>
          item.id == action.payload.id &&
          item.isApproved == action.payload.isApproved &&
          item.providerId === action.payload.providerId
      );

      if (productSelected) {
        if (productSelected.count > 1) {
          return state.map((item) => {
            if (
              item.id == action.payload.id &&
              item.isApproved == action.payload.isApproved &&
              item.providerId === action.payload.providerId
            ) {
              productSelected.count -= 1;
              return productSelected;
            } else {
              return item;
            }
          });
        }
        allState2.splice(found2, 1);
        return [...allState2];
      }
      return state;
    default:
      return state;
  }
};

const productsReducer = (state = initialState.products, action) => {
  switch (action.type) {
    case GET_PRODUCTS:
      return action.payload;
    default:
      return state;
  }
};

const showAllNumReducer = (state = initialState.showAllNum, action) => {
  switch (action.type) {
    case SET_SHOW_ALL_NUM:
      return action.payload;
    default:
      return state;
  }
};

const blogsReducer = (state = initialState.blogs, action) => {
  switch (action.type) {
    case GET_BLOGS:
      return action.payload;
    default:
      return state;
  }
};

const userReducer = (state = initialState.user, action) => {
  switch (action.type) {
    case GET_USER:
      return action.payload;
    case SET_USER:
      const user = state.find((item) => item.mobile == action.payload.mobile);
      if (!user) {
        return [...state, action.payload];
      } else {
        return [{ ...action.payload, mobile: user.mobile }];
      }
    case SET_USER_ADDRESS:
      const userInfo = state.find((item) => item.activeMapId == action.payload.activeMapId);
      if (userInfo) {
        const newUserInfo = state.filter((item) => item.id != action.payload.id);
        return [...newUserInfo, userInfo];
      }
      return [...state, action.payload];
    case REMOVE_USER:
      return state.filter((item) => item.mobile != action.payload.mobile);
    default:
      return state;
  }
};

const reducers = combineReducers({
  products: productsReducer,
  cart: cartReducer,
  blogs: blogsReducer,
  user: userReducer,
  showAllNum: showAllNumReducer,
});

export default reducers;
